import { API_AUTH } from "./common";
const HomeApi = {
  getAll: (dtFrom, dtTo) => {
    if (dtFrom && dtTo) {
      return API_AUTH.get(
        `trang-chu/getall?dtFrom=${dtFrom}&dtTo=${dtTo}`
      );
    }
    return API_AUTH.get("trang-chu/getall");
  },

  phanquyen: () => {
    return API_AUTH.get("trang-chu/phan-quyen");
  },
};

export default HomeApi;
